import StandardTabPanel from "../../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../../../components/ui library/components/tab-panels/standard/tab-header/tab-styles";

export default function Navigation({ _case, activeTab, children }) {
  const allTabs = [
    {
      key: "personal",
      name: "Personal",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case?.id}/client-info/personal`,
    },
    {
      key: "availability",
      name: "Availability",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case?.id}/client-info/availability`,
    },
    {
      key: "contact",
      name: "Contact",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case?.id}/client-info/contact`,
    },
    {
      key: "images",
      name: "Images",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case?.id}/client-info/images`,
    },
  ];

  return (
    <StandardTabPanel
      activeTab={activeTab}
      tabList={allTabs}
      headerTabSx={TAB_STYLES.SUB_TAB.SX}
      headerTabIndicatorSx={TAB_STYLES.SUB_TAB.TAB_INDICATOR_SX}
    >
      <section className="min-h-[90vh] p-4">{children}</section>
    </StandardTabPanel>
  );
}
